import { Fragment } from "react";
import { useSelector } from "react-redux";

import MenuItem from "_metronic/layout/aside/MenuItem";
import MenuItemSeparator from "_metronic/layout/aside/MenuItemSeparator";
import MenuSection from "_metronic/layout/aside/MenuSection";

import { getWorkspacePermissions } from "app/store/modules/selectors/workspaces.selector";

const MenuList = (props) => {
  const { currentUrl, menuConfig, layoutConfig, onMenuItemSelected } = props;
  const permissions = useSelector(getWorkspacePermissions);
  const canViewBilling = permissions.includes("billing.read");

  return menuConfig.aside.items.map((child, index) => {
    if (child.page === "billing" && !canViewBilling) return null;

    return (
      <Fragment key={`menuList${index}`}>
        {child.section && <MenuSection item={child} />}
        {child.separator && <MenuItemSeparator item={child} />}
        {child.title && (
          <MenuItem
            item={child}
            onMenuItemSelected={onMenuItemSelected}
            currentUrl={currentUrl}
            layoutConfig={layoutConfig}
          />
        )}
      </Fragment>
    );
  });
};

export default MenuList;
